import ConnectionRequestsTable from 'src/pages/Equipment/components/Tables/ConnectionRequestsTable'
import Segmented from '@/shared/Common/Segmented'
import { useMemo, useState } from 'react'
import { TConnectionRequestProtocol } from '@/pages/Equipment/equipment.types.ts'

const ConnectionRequestsTab = () => {
  const [protocol, setProtocol] = useState<TConnectionRequestProtocol>('lp-lift')
  const protocolOptions = useMemo(
    () => [
      { value: 'lp-lift', label: 'lp-lift' },
      { value: 'lkds', label: 'lkds' },
    ],
    []
  )

  return (
    <>
      <div className="flex-space-between center mb16">
        <div />
        <Segmented
          style={{ width: 'fit-content' }}
          options={protocolOptions}
          value={protocol}
          onChange={(value) => setProtocol(value as TConnectionRequestProtocol)}
        />
      </div>
      <ConnectionRequestsTable key={protocol} protocol={protocol} />
    </>
  )
}

export default ConnectionRequestsTab
